import React from 'react';
import { categoryList } from '../lists';
import ProductCard from './ProductCard';

/** Products grouped by category, one horizontally scrollable row per category. */
export default function ProductList({ products }) {
    const categories = products?.map((p) => p?.category);
    const nonDuplicateCategories = categories?.filter((cat, index) => categories.indexOf(cat) === index);
    const completeCat = categoryList?.filter((c) => nonDuplicateCategories?.includes(c?.name));

    return (
        <div className="w-full flex flex-col gap-6">
            {completeCat?.map((cat) => {
                const prods = products?.filter((p) => p.category === cat?.name);

                return (
                    <div key={cat?.name} className="w-full flex flex-col gap-3">
                        <div className="flex items-baseline gap-2">
                            <p className="m-0 text-[13px] font-semibold text-surface-900">{cat?.value}</p>
                            <span className="text-xs text-surface-400 tabular-nums">{prods.length}</span>
                        </div>
                        <div className="flex flex-row gap-3 w-full overflow-x-auto pb-2">
                            {prods.map((product) => (
                                <ProductCard product={product} key={product?.value} />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
